module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/ThinkBIT/work-projects/confe/hosting/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 18